// Shared by the component and its Settings panel. A leaf module on purpose:
// when Settings imported these back from the component that imports Settings,
// webpack hit the temporal dead zone and the whole page failed to mount.

// A round needs an end. Ten by default: the finish line is the point, and a
// shorter one arrives often enough to keep earning the "one more round"
// impulse. Re-asked misses make a round longer than its nominal length anyway.
export const ROUND_SIZES = [5, 10, 15, 20, 30];
export const DEFAULT_ROUND_SIZE = 10;

export const THEMES = ["auto", "light", "dark"];
export const THEME_LABELS = { auto: "Auto", dark: "Dark", light: "Light" };
